import { render } from "./TileGameLeaderBoard.vue?vue&type=template&id=0cd6945f"
import script from "./TileGameLeaderBoard.vue?vue&type=script&lang=js"
export * from "./TileGameLeaderBoard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__